module.exports = __webpack_public_path__ + "img/Illustration.d1786afa.svg";